export enum WTMTab {
  TrackerList = 0,
  HistoricalScans = 1,
}
